
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { TreeStructure, TreeType } from "@gsx/common";
import { Container } from "inversify";

const isProduct = (tag: string): boolean =>
    tag.toLowerCase().startsWith(TreeType.Product.toLowerCase());
const isService = (tag: string): boolean =>
    tag.toLowerCase().startsWith(TreeType.Service.toLowerCase());
const isRegime = (tag: string): boolean =>
    tag.toLowerCase().startsWith(TreeType.OperatingRegime.toLowerCase());
const isApplication = (tag: string): boolean =>
    tag.toLowerCase().startsWith(TreeType.Applications.toLowerCase());
const isCustom = (tag: string): boolean =>
    tag.toLowerCase().startsWith(TreeType.Custom.toLowerCase());

@Component
export default class TreeNode extends Vue {
    @Prop() value!: TreeStructure;
    @Prop() toggle!: (name: string) => void;
    @Prop() filterStore!: any;
    @Inject("container") container!: Container;
    active: boolean = false;

    get hasChildren(): boolean {
        return Array.isArray(this.value.children) && this.value.children.length > 0;
    }

    get checked(): boolean {
        if (isProduct(this.value.id)) {
            return this.filterStore.productTags.has(this.value.id);
        } else if (isService(this.value.id)) {
            return this.filterStore.serviceTags.has(this.value.id);
        } else if (isRegime(this.value.id)) {
            return this.filterStore.operatingRegimeTags.has(this.value.id);
        } else if (isApplication(this.value.id)) {
            return this.filterStore.applicationTags.has(this.value.id);
        } else if (isCustom(this.value.id)) {
            return this.filterStore.customTags.has(this.value.id);
        }

        return false;
    }

    toggleActive(): void {
        this.active = !this.active;
    }

    updateChecked(e: any): void {
        if (e.target.checked !== this.checked) {
            if (isProduct(this.value.id)) {
                this.filterStore.toggleProduct(this.value.id);
            } else if (isService(this.value.id)) {
                this.filterStore.toggleService(this.value.id);
            } else if (isRegime(this.value.id)) {
                this.filterStore.toggleOperatingRegime(this.value.id);
            } else if (isApplication(this.value.id)) {
                this.filterStore.toggleApplication(this.value.id);
            } else if (isCustom(this.value.id)) {
                this.filterStore.toggleCustomTags(this.value.id);
            }
        }
    }
}
